import { render, staticRenderFns } from "./page-device.vue?vue&type=template&id=52c1b0c5&scoped=true&"
import script from "./page-device.vue?vue&type=script&lang=js&"
export * from "./page-device.vue?vue&type=script&lang=js&"
import style0 from "./page-device.vue?vue&type=style&index=0&id=52c1b0c5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c1b0c5",
  null
  
)

export default component.exports